/**
 * Normalize Laika RAG source labels for display under a bot message.
 */
export function formatLaikaSources(sources?: string[] | null): string[] {
  if (!sources || sources.length === 0) return [];
  const seen = new Set<string>();
  const out: string[] = [];
  for (const raw of sources) {
    const label = humanizeLaikaSource(String(raw || ''));
    if (!label || seen.has(label)) continue;
    seen.add(label);
    out.push(label);
  }
  return out.slice(0, 5);
}

const SOURCE_ALIASES: Record<string, string> = {
  'cgv contrats': 'CGV / contrats',
  'facturation': 'Facturation',
  'onboarding': 'Premiers pas',
  'onboarding nouveau pro': 'Premiers pas',
  'demarrage onboarding': 'Premiers pas',
  'demarrage checklist': 'Premiers pas',
  'notes seance': 'Notes de séance',
  'notes séance': 'Notes de séance',
  'notes seances': 'Notes de séance',
  'sms credits': 'Crédits SMS',
  'google calendar sync': 'Google Calendar',
  'google calendar': 'Google Calendar',
  'tampon trajet': 'Tampon de trajet',
  'frais deplacement': 'Frais de déplacement',
  'widget reservation': 'Widget de réservation',
  'equipe collaborateurs': 'Équipe',
  'disponibilites service': 'Disponibilités',
  'disponibilites services': 'Disponibilités',
  'disponibilites': 'Disponibilités',
  'planning capacite bandes': 'Planning capacité',
  'planning capacite': 'Planning capacité',
  'forfaits packs credits': 'Forfaits',
  'forfaits credits': 'Forfaits',
  'forfaits avances': 'Forfaits',
  'rappels automatiques': 'Rappels',
  'paiements stripe': 'Paiements',
  'stripe setup': 'Paiements',
  'educateur canin': 'Éducateur canin',
  'terms and privacy': 'CGU / confidentialité',
  'refund policy': 'Remboursements',
  'legal escalation': 'Support légal',
};

export function humanizeLaikaSource(raw: string): string {
  let s = raw
    .replace(/^\[Source:\s*/i, '')
    .replace(/\]$/, '')
    .replace(/^SOURCE:\s*/i, '')
    .replace(/^notion:\/\//i, '')
    .replace(/^local:\/\//i, '')
    .trim();
  s = s.replace(/\\/g, '/');
  s = s.replace(/^.*knowledge_base\//i, '');
  s = s.replace(/^product\/(features\/)?/i, '');
  s = s.replace(/^guides_metier\//i, '');
  s = s.replace(/^guides\//i, '');
  s = s.replace(/^faq\//i, 'faq ');
  s = s.replace(/^policies\//i, '');
  s = s.replace(/\.(md|txt|markdown)$/i, '');
  s = s.replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();
  s = s.replace(/\s+parcours$/i, '');
  s = s.replace(/\s+ui$/i, '');
  if (!s) return '';
  if (/^faq\s/i.test(s)) {
    s = 'FAQ ' + s.slice(4).trim();
  }
  const aliased = SOURCE_ALIASES[s.toLowerCase()];
  if (aliased) return aliased;
  return s.charAt(0).toUpperCase() + s.slice(1);
}
